/**
 * Asynchronously reads the contents of an array of files,
 * converting them to base64 strings.
 *
 * @param {File[]} files - The array of files to read.
 * @return {Promise<string[]>} A promise that resolves to an array of base64 strings.
 */

export async function convertFilesToBase64String(
  files: File[],
): Promise<string[]> {
  const base64Strings = await Promise.all(
    files.map(async (file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      const currentBase64String = await new Promise<string>((resolve) => {
        reader.onload = () => resolve(reader.result?.toString() || '');
      });

      return currentBase64String;
    }),
  );
  return base64Strings;
}
